// EPI 服务预设 (Admin/ServicePreset) SectionFunction —— Client Portal 版
// Client 用户自己维护自己的预设；用 SelectServiceRequestTypeForm 作 additionalForm 选服务类型
// addBySection / editBySection 都直接拿独立 Section 的 sectionComponent，无 TabSection 包裹
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

// 新增：打开 Create 模态框，重置 additionalForm 内部 state 并加载分组数据
export function addBySection({ sectionComponent } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Create' });
  // 等模态框挂载后再操作 additionalForm 子组件
  setTimeout(() => {
    const addForm = sectionComponent.customForm.current?.additionalFormRef?.current?.child?.current;
    addForm?.setState({
      defaultSelectedRowKeys: [],
      serviceRequestTypeIdList: [],
      groupSelectedKeys: {},
    });
    addForm?.getServiceRequestTypeData();
    // 清表单字段 (Name / IsDefault / ServiceRequestTypeIdList)
    sectionComponent.customForm.current?.formRef.current?.resetFields();
  }, config.setTimeoutMilliSecond * 10);
}

// 编辑：拉取详情 → 填表单 → 注入 defaultSelectedRowKeys 让 additionalForm 预勾选
export function editBySection({ parameter, sectionComponent, pageComponent, sectionName } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Edit' });
  setTimeout(() => {
    httpClient
      .get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
      .then(({ data }) => {
        if (!data.result) {
          globalFunction.handleResultError(data, pageComponent);
          return;
        }
        // 普通字段
        sectionComponent.customForm.current?.setState({ currentDataKey: data.data.key });
        sectionComponent.customForm.current?.formRef.current?.setFieldsValue({
          Name: data.data.Name,
          IsDefault: data.data.IsDefault,
          ServiceRequestTypeIdList: data.data.ServiceRequestTypeIdList || [],
          key: data.data.key,
        });
        sectionComponent.customForm.current?.setState({ formData: data.data });

        // 把已选 ID 列表注入到 additionalForm，使其加载完分组后能预勾选
        const defaultSelectedRowKeys = (data.data.ServiceRequestTypeIdList || []).slice();
        setTimeout(() => {
          const addForm = sectionComponent.customForm.current?.additionalFormRef?.current?.child?.current;
          addForm?.setState({
            defaultSelectedRowKeys,
            serviceRequestTypeIdList: defaultSelectedRowKeys,
            groupSelectedKeys: {},
          });
          // 先 setState 再加载，加载完触发 initGroupSelectedKeysWithDefault
          addForm?.getServiceRequestTypeData();
        }, config.setTimeoutMilliSecond * 10);
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }, config.setTimeoutMilliSecond);
}
